import { render, staticRenderFns } from "./ElementTextExtra.vue?vue&type=template&id=953e693c"
import script from "./ElementTextExtra.vue?vue&type=script&lang=ts"
export * from "./ElementTextExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports